import React from 'react';
import { AccordionItem, Icon } from '@cb/apricot-react';

interface AccordionItemWrapperProps {
  glyphIcon?: string;
  title?: React.ReactNode;
  children?: React.ReactNode;
  // eslint-disable-next-line
  [key: string]: any; // Allow other props to be passed through
}

const AccordionItemWrapper = React.forwardRef<HTMLElement, AccordionItemWrapperProps>((props, ref) => {
  const { glyphIcon, children, ...restProps } = props;
  let { title } = props;

  if (glyphIcon && title) {
    title = (
      <div className='display-flex align-items-center'>
        <Icon name={glyphIcon.replace(/^cb-/, '')} color='blue2' decorative />
        <span className='cb-margin-left-8 cb-font-weight-medium'>{title}</span>
      </div>
    );
  }

  return (
    <AccordionItem ref={ref} {...restProps} title={title}>
      {children}
    </AccordionItem>
  );
});

AccordionItemWrapper.displayName = 'AccordionItemWrapper';

export default AccordionItemWrapper;
